module.exports = __webpack_public_path__ + "img/callus.89c951e6.png";